module.exports = __webpack_public_path__ + "/img/de0f189a0a188c32ce025bb70f5963f4.png";